export default __webpack_public_path__ + "static/media/MOON.7f64b4d0.png";